
import React from "react";
import { BookOpen } from "lucide-react";
import { SectionHeader } from "@/components/ui/section-header";

export function GuideHeader() {
  return (
    <>
      <div className="flex items-center justify-center gap-3 mb-2">
        <BookOpen className="w-6 h-6 text-grandpal-green-dark" />
        <span className="text-sm font-medium uppercase tracking-wider text-grandpal-green-dark">Resources Hub</span>
      </div>

      <SectionHeader 
        title="Helpful Guides & Resources" 
        subtitle="Access our comprehensive collection of guides to help you navigate elderly care decisions with confidence." 
        centered 
        className="mb-16" 
      />
    </>
  );
}
